import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';


const ResponseInput = ({ 
  onSubmit, 
  isLoading, 
  minWords = 50, 
  maxWords = 200,
  buttonText = "Submit Response"
}) => {
  const [response, setResponse] = useState('');
  const [wordCount, setWordCount] = useState(0);

  useEffect(() => {
    const words = response?.trim()?.split(/\s+/)?.filter(word => word?.length > 0);
    setWordCount(words?.length);
  }, [response]);

  const handleSubmit = () => {
    if (wordCount >= minWords && wordCount <= maxWords) {
      onSubmit(response);
    }
  };

  const isValid = wordCount >= minWords && wordCount <= maxWords;
  const isUnderMin = wordCount < minWords;
  const isOverMax = wordCount > maxWords;

  return (
    <div className="bg-card border border-border rounded-2xl p-6">
      <h3 className="text-xl font-bold text-foreground mb-4">Your Response</h3>
      
      <textarea
        value={response}
        onChange={(e) => setResponse(e?.target?.value)}
        placeholder="Type your sales response here... Be specific, confident, and focus on addressing the customer's needs."
        className="w-full min-h-[200px] p-4 bg-background border border-input rounded-xl text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring resize-none"
        disabled={isLoading}
      />
      
      <button
        onClick={handleSubmit}
        disabled={isLoading || wordCount < minWords}
        className={`w-full py-3 px-6 rounded-lg font-semibold transition-colors ${
          isLoading || wordCount < minWords
            ? 'bg-muted text-muted-foreground cursor-not-allowed'
            : 'bg-primary text-white hover:bg-primary/90'
        }`}
      >
        {isLoading ? buttonText : 'Submit to Lumo'}
      </button>

      <div className="mt-4 space-y-3">
        <div className="flex items-start gap-2 text-sm text-muted-foreground">
          <Icon name="Info" size={16} className="flex-shrink-0 mt-0.5" />
          <p>
            Craft a response that demonstrates clarity, confidence, and control. 
            Focus on understanding the customer's needs and guiding them toward a close.
          </p>
        </div>

        {isUnderMin && wordCount > 0 && (
          <div className="flex items-start gap-2 text-sm text-warning">
            <Icon name="AlertCircle" size={16} className="flex-shrink-0 mt-0.5" />
            <p>Your response needs at least {minWords - wordCount} more words.</p>
          </div>
        )}

        {isOverMax && (
          <div className="flex items-start gap-2 text-sm text-error">
            <Icon name="AlertCircle" size={16} className="flex-shrink-0 mt-0.5" />
            <p>Your response exceeds the limit by {wordCount - maxWords} words.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResponseInput;